import { api } from "@/api/client"

export async function updateUserCity(cityId: number): Promise<void> {
  await api.patch("/user/city", { city_id: cityId })
}
